import { Button, Link, Stack, Typography } from '@mui/material'
import { ArticleControlShare } from 'features/Article/components/ArticleControlShare/ArticleControlShare'
import { UIItemContentContainer, UIShadowContainer } from 'features/UI'
import React from 'react'
import { TimelineItemHeader } from '../../../features/Timeline/components/TimelineItemHeader/TimelineItemHeader'

interface Props {
  id: number
  title: string
  author: string
  date: string
  text: string
  link?: string
  showActions: boolean
  isShared: boolean

  onDelete: () => void
  onReviewLater: () => void
  onDone: () => void
}

const DrawerNoteItem = (props: Props) => {
  const {
    id,
    title,
    author,
    date,
    text,
    link,
    showActions,
    isShared,
    onDelete,
    onReviewLater,
    onDone,
  } = props

  return (
    <UIShadowContainer>
      <UIItemContentContainer>
        <TimelineItemHeader title={title} authorName={author} date={date} showAvatar={true} />
        <Typography paddingY={2}>{text}</Typography>
        {link && (
          <Link href={link} target="_blank" rel="noopener noreferrer" underline="hover" mb={2}>
            {link}
          </Link>
        )}
        {showActions && (
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" spacing={2}>
              <ArticleControlShare entityId={id} entityType="note" />
            </Stack>
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="outlined" color="error" onClick={onDelete}>
                Delete
              </Button>
              <Button variant="contained" onClick={onReviewLater}>
                Continue Later
              </Button>
              <Button variant="contained" onClick={onDone}>
                Done
              </Button>
            </Stack>
          </Stack>
        )}

        {isShared && (
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" onClick={onReviewLater}>
              Continue Later
            </Button>
            <Button variant="contained" onClick={onDone}>
              Done
            </Button>
          </Stack>
        )}
      </UIItemContentContainer>
    </UIShadowContainer>
  )
}

export default React.memo(DrawerNoteItem)
